import React, { ReactNode, createContext, useEffect, useReducer } from "react";

// Define the shape of the state
interface ReAuthState {
  isReauthenticated?: boolean;
  purpose?: string;
}

//Reducer Action
export type ReAuthAction = | { type: 'SET_REAUTH'; payload: ReAuthState } | { type: 'RESET_REAUTH'};

interface ReAuthContextProps {
  state: ReAuthState;
  dispatch: React.Dispatch<ReAuthAction>;
}

// Default value for the context
const defaultReauthState: ReAuthState = {
  isReauthenticated: false,
  purpose: '',
};

export const reauthReducer = (state: ReAuthState, action: ReAuthAction): ReAuthState => {
  switch (action.type) {
    case 'SET_REAUTH' : {
      return {
        ...state,
        ...action.payload 
      }
    }
    case 'RESET_REAUTH': {
      return {
        ...state,
        isReauthenticated: false,
        purpose: '',
      };
    }
    default:
      return state;
  }
}

export const ReAuthContext = createContext<ReAuthContextProps>({
  state: defaultReauthState,
  dispatch: () => {},
})

interface ReAuthProviderPros {
  children: ReactNode;
}

const loadState = (): ReAuthState => {
  const savedState = sessionStorage.getItem('reAuthState');
  return savedState ? JSON.parse(savedState): defaultReauthState;
};

export const ReAuthProvider: React.FC<ReAuthProviderPros> = ({ children }) => {
  const [state, dispatch] = useReducer( reauthReducer, loadState());

  useEffect(() => {
    sessionStorage.setItem('reAuthState', JSON.stringify(state));
  }, [state]);

  return (
    <ReAuthContext.Provider value={{ state, dispatch}}>
      {children}
    </ReAuthContext.Provider>
  );
}